import { createContext, useContext, type ReactNode } from 'react';
import type { WorkActionPresentation } from '@shared/types/work-action';
import type { WorkDocumentOutput } from '@/lib/work-document-output';

interface WorkSurface { actionsElsewhere?: boolean; onResultTitleChange?: (title: string) => void; resultSource?: { kind: 'task_action' | 'flow'; id: string; output?: WorkDocumentOutput }; actions: WorkActionPresentation[]; sourceRunId?: string | null; historical?: boolean }
const Context = createContext<WorkSurface | null>(null);
export const WorkActionsProvider = ({ children, ...value }: WorkSurface & { children: ReactNode }) => <Context.Provider value={value}>{children}</Context.Provider>;
export const useWorkActions = () => useContext(Context);
